export { default } from './Banner';

require('./banner.scss');